<template>
  <Modal
    :container-style="{ maxWidth: '440px' }"
    :show="showModal"
    body-class="atb-border-none"
    footer-class="atb-flex atb-flex-row atb-justify-end atb-gap-8"
    @onModalClose="
      [closeConfirmationPopupModalHandler, closeConfirmationPopupIndex]
    "
  >
    <template #header>
      {{ $t('areYouSure') }}
    </template>
    <template #body>
      <div class="atb-flex atb-flex-col atb-gap-4">
        <span id="confirmationPopupChangesMade"> {{ $t('changesMade') }} </span>
      </div>
    </template>
    <template #footer>
      <Button
        class="button"
        motif="basic"
        id="confirmationPopupOkayButton"
        @click="closeConfirmationPopupIndex()"
      >
        {{ $t('ok') }}
      </Button>
      <Button
        class="button"
        @click="closeConfirmationPopupModalHandler()"
        >{{ $t('cancel') }}</Button
      >
    </template>
  </Modal>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';
  import Modal from '@atb-ui/eds-vue/src/components/Modal.vue';
  import Button from '@atb-ui/eds-vue/src/components/Button.vue';

  interface ConfirmationPopupEvents {
    (_event: 'closeActionPopup'): void;
    (_event: 'closeConfirmationIndex', _params: number): void;
  }
  interface ConfirmationPopupProps {
    index?: number;
  }

  const emit = defineEmits<ConfirmationPopupEvents>();
  const props = withDefaults(defineProps<ConfirmationPopupProps>(), {
    index: 0,
  });
  const showModal = ref(true);

  const closeConfirmationPopupModalHandler = () => {
    showModal.value = false;
    emit('closeActionPopup');
  };

  const closeConfirmationPopupIndex = () => {
    showModal.value = false;
    emit('closeConfirmationIndex', props.index);
  };
</script>
<style>
  .button {
    width: 80px;
  }
</style>
